import styled from 'styled-components'

export const PageWrapper = styled.div`
  flex: 1 0;
  display: flex;
  position: relative;
`
